if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');      
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.quantityInput = this.form.elements.namedItem('quantity');
      this.quantityInput?.addEventListener('input', () => this.clearQuantityError());
      this.quantityInput?.addEventListener('change', () => this.clearQuantityError());
      const variantJSON = this.closest('section')?.querySelector('variant-radios script[type="application/json"], variant-selects script[type="application/json"], script[id^="ProductJSON-"]');
      if (variantJSON && this.quantityInput) {
        try {
          const productData = JSON.parse(variantJSON.textContent);
          const variants = Array.isArray(productData) ? productData : productData.variants;
          const variant = variants?.find(item => String(item.id) === this.form.elements.namedItem('id').value);
          this.quantityInput.closest('quantity-input')?.setVariantRules(variant?.quantity_rule);
        } catch (error) {
          // Keep the native constraints when optional rule data cannot be read.
        }
      }
    }

  async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true') return;
      if (!this.validateQuantity()) return;

      this.handleErrorMessage();
      this.error = false;

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      const spinner = this.querySelector('.loading-overlay__spinner');
      spinner?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);   
      
       if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.section || section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

      
      config.body = formData;
    

      try {
        await enqueueNovaCartMutation(async () => {
          const result = await fetch(`${routes.cart_add_url}`, config);
          const response = await result.json();
          if (!result.ok || response.status) {
            throw Object.assign(new Error(response.description || window.cartStrings.error), { novaUserMessage: true });
          }
          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          await refreshNovaCartState();
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) quickAddModal.hide(true);
          this.cart.renderContents(response);
        });
      } catch (error) {
        this.handleErrorMessage(error.novaUserMessage ? error.message : window.cartStrings.error);
      } finally {
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          spinner?.classList.add('hidden');
      }
    }


    validateQuantity() {
      if (!this.quantityInput) return true;
      this.clearQuantityError();
      const value = this.quantityInput.valueAsNumber;
      const positiveInteger = Number.isInteger(value) && value > 0;
      if (positiveInteger && this.quantityInput.checkValidity()) return true;

      const message = positiveInteger ? this.quantityInput.validationMessage : 'Enter a whole number quantity of at least 1.';
      if (!positiveInteger) this.quantityInput.setCustomValidity(message);
      this.handleErrorMessage(message);
      this.quantityError = true;
      this.quantityDescription = this.quantityInput.getAttribute('aria-describedby');
      this.quantityInvalid = this.quantityInput.getAttribute('aria-invalid');
      this.quantityInput.setAttribute('aria-invalid', 'true');
      this.quantityInput.setAttribute('aria-describedby', [...new Set([...(this.quantityDescription || '').split(/\s+/).filter(Boolean), this.errorMessageWrapper.id])].join(' '));
      this.quantityInput.focus();
      return false;
    }

    clearQuantityError(clearMessage = true) {
      if (!this.quantityError) return;
      this.quantityError = false;
      this.quantityInput.setCustomValidity('');
      for (const [attribute, value] of [['aria-describedby', this.quantityDescription], ['aria-invalid', this.quantityInvalid]]) {
        if (value === null) this.quantityInput.removeAttribute(attribute);
        else this.quantityInput.setAttribute(attribute, value);
      }
      if (clearMessage) this.handleErrorMessage();
    }

    handleErrorMessage(errorMessage = false, retryAction = null) {
      this.clearQuantityError(false);
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper && errorMessage) {
        this.errorMessageWrapper = document.createElement('div');
        this.errorMessageWrapper.className = 'product-form__error-message-wrapper';
        this.errorMessageWrapper.setAttribute('role', 'alert');
        this.errorMessage = document.createElement('span');
        this.errorMessage.className = 'product-form__error-message';
        this.errorMessageWrapper.appendChild(this.errorMessage);
        this.appendChild(this.errorMessageWrapper);
      }
      if (!this.errorMessageWrapper) return;
      if (!this.errorMessageWrapper.id) this.errorMessageWrapper.id = `ProductFormError-${this.form.id}`;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.querySelector('[data-nova-variant-retry]')?.remove();

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
        if (retryAction) {
          const retryButton = document.createElement('button');
          retryButton.type = 'button';
          retryButton.className = 'button button--secondary';
          retryButton.setAttribute('data-nova-variant-retry', '');
          retryButton.textContent = 'Retry price update';
          retryButton.addEventListener('click', () => {
            retryButton.disabled = true;
            retryAction();
          });
          this.errorMessageWrapper.appendChild(retryButton);
        }
      }
    }
  });
}
